import { render, staticRenderFns } from "./SetupHealthPanel.vue?vue&type=template&id=737bf4c4&scoped=true"
import script from "./SetupHealthPanel.vue?vue&type=script&lang=js"
export * from "./SetupHealthPanel.vue?vue&type=script&lang=js"
import style0 from "./SetupHealthPanel.vue?vue&type=style&index=0&id=737bf4c4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737bf4c4",
  null
  
)

export default component.exports